<template>
  <button
    @click="handleClick"
    class="toggle-button"
    aria-label="Toggle"
  >
    <span v-if="label" class="toggle-button-label"> {{ label }} </span>
    <span class="toggle-button-icon"></span>
  </button>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  emits: ['click'],
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/color-theme';

  .toggle-button{
    display: flex;
    padding: 1rem .5rem;
    align-items: center;
    background-color: transparent;
    border: 0;
    box-sizing: border-box;

    &-label {
      color: $gray-800;
      font-weight: 600;
      margin-right: 1rem;
    }

    &-icon {
      position: relative;
      display: block;
      width: 18px;
      height: 2px;
      background-color: $gray-800;

      &:before,
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        left: 0;
        background-color: $gray-800;
      }

      &:before {
        top: -6px;
      }

      &:after {
        bottom: -6px;
      }
    }
  }

</style>
